angular = require('angular')
class CompanyFactory
  @$injector: ['RestfulResource', '$http','config']
  constructor: (RestfulResource, $http, config)->    
    url = "#{config.api.url}/companies/"    
    actions =       
      parents:
        medthod: 'GET'
        url: "#{url}/:_id/parents/"
        isArray: true
    Company = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)         
    return Company
module.exports = CompanyFactory




// WEBPACK FOOTER //
// ./src/component/company/company.coffee